import FunctionHeader from "presentation/components/Header/FunctionHeader";
import Spinner from "presentation/components/Shared/Spinner";
import UserPanel from "presentation/components/User/UserPanel";
import usePermissionCheck from "presentation/hooks/use-check-permissions";

const UserPage = ({ children }: { children?: React.ReactNode }) => {
  const { isLoading } = usePermissionCheck({ requiredFunction: "users" });

  if (isLoading) {
    return <Spinner />;
  }
  return (
    <div>
      <FunctionHeader title="Utilizadores" />
      <UserPanel />
    </div>
  );
};

export default UserPage;
